<template>
    <div id="ProjectViewInvitesupplier">
        <eb-panel>
            <eb-panel-header class="panel-header" slot="header">
                <span slot="title">2 采购范围</span>
            </eb-panel-header>
            <div slot="body">
                <div class="panel-body-row">
                    <div class="panel-body-row-left">采购范围</div>
                    <div class="panel-body-row-right">{{project.buyScope| buyScope}}</div>
                </div>
            </div>
        </eb-panel>
    </div>
</template>
<script>
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
export default {
  name: 'ProjectViewInvitesupplier',
  props: {
    project: {
      required: true
    }
  },
  components: {
    ebPanel,
    ebPanelHeader
  }
};
</script>
<style>

</style>
